/**
 * @public
 * isAuthLibraryLoaded: verify if the authetication library is loaded
 * @param {Object} state of the Redux store. 
 *
 * @returns true when the library is already loaded otherwise false.
 */
export const isAuthLibraryLoaded = (state) => !!state?.authentication?.isAuthLibraryLoaded;

/**
 * @public
 * isAuthLibraryNotLoaded: verify if the authetication library is not loaded
 * @param {Object} state of the Redux store. 
 *
 * @returns true when the library is not already loaded otherwise false.
 */
export const isAuthLibraryNotLoaded = (state) => state?.authentication?.isAuthLibraryLoaded === false;

/**
 * @public
 * isAuthModalOpen: verify if the authetication modal is currently open in the user screen.
 * @param {Object} state of the Redux store. 
 *
 * @returns true when modal is opening otherwise false.
 */
export const isAuthModalOpen = (state) => !!state?.modal?.isAuthModalOpen;